// Simple toast wrapper - uses the simple-toast system (no Radix UI portals)
import { toast as simpleToast } from '../components/ui/simple-toast';

export const toast = {
  success: (message) => {
    simpleToast.success(message);
  },
  error: (message) => {
    simpleToast.error(message);
  },
  info: (message) => {
    simpleToast.info(message);
  },
  warning: (message) => {
    simpleToast.warning(message);
  },
};
